import { FC } from 'react';
import { BannerUpsellingStoryblok } from 'storyblok-types';
import { Link } from 'atoms/Link/Link';
import { Picture } from 'atoms/Picture';
import { Modal } from 'molecules/Modal';
import { DialogProps } from 'modules/mui/types';
import styles from './styles.module.css';

export const UpsellingBannerModal: FC<
  DialogProps & { banner: BannerUpsellingStoryblok }
> = ({ open, onClose, banner, ...props }) => {
  return (
    <Modal
      {...props}
      open={open}
      onClose={onClose}
      classes={{
        root: styles.modal,
        container: styles.modalContainer,
        paper: styles.modalPaper,
      }}
    >
      <Link href={banner.link} className={styles.link}>
        <Picture
          srcDesktop={banner.desktopImage}
          srcMobile={banner.mobileImage}
        />
      </Link>
    </Modal>
  );
};
